import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';

import groupByTime from '../groupByTime';

function parsePagesCrawledRawData(response: AggregatedMetrics.PagesCrawledResult) {
  const groupedByTime = groupByTime<AggregatedMetrics.PagesCrawledResult>(response);

  const crawlersValues: Record<string, number[]> = {};
  let totalUncached = 0;
  let totalRequests = 0;

  const uncachedValuesList = groupedByTime.map((item) => {
    const { uncached, total } = item.data.reduce(
      (acc, entry) => {
        crawlersValues[entry.crawler] = Array(response.intervals.length).fill(0); // saves a loop

        acc.uncached += entry.total_cache_miss;
        acc.total += entry.total_o_count;
        return acc;
      },
      { uncached: 0, total: 0 }
    );
    totalUncached += uncached; // saves a loop
    totalRequests += total; // saves a loop

    return total === 0 ? 0 : +((uncached / total) * 100).toFixed(2);
  });

  groupedByTime.forEach((item, index) => {
    item.data.forEach((datapoint) => {
      crawlersValues[datapoint.crawler][index] += datapoint.total_o_count;
    });
  });

  const crawlersValuesList = Object.entries(crawlersValues);

  const sortedTotalRequestPerCrawlerList: [string, number][] = crawlersValuesList
    .map(([crawler, values]) => [crawler, values.reduce<number>((sum, value) => sum + value, 0)] as [string, number])
    .sort((a, b) => {
      const valueA = a[1] as number;
      const valueB = b[1] as number;
      return valueB - valueA;
    }) as [string, number][];

  const sortedCrawlersValuesList = Object.entries(
    sortedTotalRequestPerCrawlerList.reduce<Record<string, number[]>>((acc, crawler) => {
      acc[crawler[0]] = crawlersValues[crawler[0]];
      return acc;
    }, {})
  );

  const totalUncachedPercentage = totalRequests === 0 ? 0 : (totalUncached / totalRequests) * 100;

  return {
    uncachedValuesList,
    crawlersValuesList: sortedCrawlersValuesList,
    totalRequestPerCrawlerList: sortedTotalRequestPerCrawlerList,
    totalRequests,
    totalUncachedPercentage,
  };
}

export default parsePagesCrawledRawData;
